import { withStyles } from '@material-ui/core/styles';
import Grid from '@material-ui/core/Grid';

export default withStyles({
  root: {
    display: ({ hide }) => hide ? 'none' : 'block',
  },
})(Grid);
